let map;
let triangle;
let lines = [];
let show_parking = false;
function initMap() {

    if(document.getElementById("map") === undefined || document.getElementById("map") === null){
        return;
    }

    var myStyles =[
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [
                { visibility: "off" }
            ]
        }
    ];

    map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 47.5041, lng: 19.135151 },
        zoom: 16,
        styles: myStyles
    });

    const svgMarker = {
        path: "M 26.91687,78.385887 C 4.21406,45.473587 0,42.095787 0,29.999987 0,13.431387 13.43141,-1.2500218e-5 30,-1.2500218e-5 c 16.56859,0 30,13.431399500218 30,29.999999500218 0,12.0958 -4.21406,15.4736 -26.91688,48.3859 -1.48984,2.1522 -4.67656,2.1521 -6.16625,0 z M 30.5,41.999987 c 6.90359,0 12.5,-5.5964 12.5,-12.5 0,-6.9036 -5.59641,-12.5 -12.5,-12.5 -6.90359,0 -12.5,5.5964 -12.5,12.5 0,6.9036 5.59641,12.5 12.5,12.5 z",
        fillColor: "#741688",
        fillOpacity: 0.99,
        strokeWeight: 0,
        rotation: 0,
        scale: 0.6,
        anchor: new google.maps.Point(40, 80),
    };

    new google.maps.Marker({
        position: { lat: 47.5041, lng: 19.135151 },
        map,
        icon: svgMarker,
        title: "Zuglói Fogászati és Implantációs Központ",
    });


    const triangleCoords = [[
        { lat: 47.505779, lng: 19.136971 },
        { lat: 47.506055, lng: 19.139546 },
        { lat: 47.505314, lng: 19.139704 },
        { lat: 47.505035, lng: 19.137145 },
        { lat: 47.505779, lng: 19.136971 }
    ],[
        { lat: 47.503029, lng: 19.136857 },
        { lat: 47.503569, lng: 19.141775 },
        { lat: 47.502083, lng: 19.142014 },
        { lat: 47.501561, lng: 19.137138 },
        { lat: 47.503029, lng: 19.136857 }
    ]
    ];

    triangle = new google.maps.Polygon({
        paths: triangleCoords,
        strokeColor: "#741688",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#741688",
        fillOpacity: 0.35,
    });

    const lineCoordinates = [[
        { lat: 47.508349, lng: 19.127339 },
        { lat: 47.505885, lng: 19.131529 },
        { lat: 47.505369, lng: 19.132297 }
    ],[
        { lat: 47.508847, lng: 19.128201 },
        { lat: 47.505623, lng: 19.133576 },
        { lat: 47.50551, lng: 19.133635 }
    ],[
        { lat: 47.504888, lng: 19.135112 },
        { lat: 47.503816, lng: 19.135346 }
    ]
    ];

    for(let i=0;i<lineCoordinates.length;i++) {
        lines.push(new google.maps.Polyline({
            path: lineCoordinates[i],
            geodesic: true,
            strokeColor: "#741688",
            strokeOpacity: 1.0,
            strokeWeight: 6,
        }));
    }
}

function show_parking_f(){
    show_parking = !show_parking;

    if(show_parking) {
        triangle.setMap(map);
    }else{
        triangle.setMap(null);
    }

    for(let i=0;i<lines.length;i++) {
        if(show_parking) {
            lines[i].setMap(map);
        }else{
            lines[i].setMap(null);
        }
    }
}
(function($) {
    $(() => {
        $('#show_parking').on('click', function (e) {
            show_parking_f();
        });
    });
})(jQuery);